import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { map, noop, isEmpty } from 'lodash';
import { commaFormatted, dateFormat } from '../../../../utils/transformer.util';
import { Button } from '../../../../components/base';
import { printJournalKAS } from '../../../../utils/print.util';

function onClickPrint(header, content, footer) {
  printJournalKAS(header, content, footer);
}

export default class BankJournal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      journal: {},
    };
    this._onGetDetails = this._onGetDetails.bind(this);
  }

  componentDidMount() {
    this._onGetDetails();
  }

  async _onGetDetails() {
    const { handleGetBankJournal, match } = this.props;
    const { id } = match.params;
    try {
      const payload = await handleGetBankJournal({ id });
      this.setState({
        journal: payload,
      });
    } catch (err) {
      // err action
    }
  }

  render() {
    const { journal } = this.state;
    return (
      <div>
        <Button
          title="Print"
          onClick={() => {
            onClickPrint('detail-bank-journal__header',
              'detail-bank-journal__table',
              'detail-bank-journal__footer');
          }}
        />
        <div id="detail-bank-journal" className="detail-bank-journal">
          {
            !isEmpty(journal) && (
              <div className="detail-bank-journal__content">
                <div className="detail-bank-journal__header">
                  <div className="detail-bank-journal__header-top">
                    <div className="detail-bank-journal__header-top--left">
                    <p>{journal.unit.school_unit.name}</p>
                      <p>{journal.bank_account || '-'}</p>
                    </div>
                    <div className="detail-bank-journal__header-title">
                      <h1>{journal.isCredit === false ? 'BUKTI BANK KELUAR' : 'BUKTI BANK MASUK'}</h1>
                    </div>
                    <div className="detail-bank-journal__header-top--right">
                      <p>Nomor: {journal.journal_number}</p>
                      <p>Tanggal: {dateFormat(journal.date)}</p>
                    </div>
                  </div>
                </div>
                <div className="detail-bank-journal__body">
                  <table className="detail-bank-journal__table">
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Kode</th>
                        <th>Nama Perkiraan</th>
                        <th>Keterangan Transaksi</th>
                        <th>Jumlah Rp</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                      map(journal.details, (list, idx) => (
                        <tr key={`journal_detail_${idx}`}>
                          <td>{idx + 1}</td>
                          <td>{list.code_of_account}</td>
                          <td>{list.parameter_code.title}</td>
                          <td>{list.description}</td>
                          <td>{commaFormatted(list.amount)}</td>
                        </tr>
                      ))
                    }
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="4" className="nominal">TOTAL</td>
                        <td className="nominal">{commaFormatted(journal.total)}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                {/* <div className="pagebreak" /> */}
                <div className="detail-bank-journal__footer">
                  <div className="detail-bank-journal__footer-bottom">
                    <div>
                      <p>Diserahkan oleh:</p>
                      <p>{journal.submitted_by}</p>
                    </div>
                    <div>
                      <p>Diterima oleh:</p>
                      <p>{journal.accepted_by}</p>
                    </div>
                    <div>
                      <p>Dibukukan oleh:</p>
                      <p>{journal.booked_by}</p>
                    </div>
                    <div>
                      <p>Diketahui oleh:</p>
                      <p>Name 4</p>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </div>
    );
  }
}
BankJournal.propTypes = {
  handleGetBankJournal: PropTypes.func,
  match: PropTypes.object.isRequired,
};
BankJournal.defaultProps = {
  handleGetBankJournal: noop,
};
